module.exports = __webpack_public_path__ + "static/media/logo-100oa.061c7494.svg";